<script>
  import options from './FormInputRichText.options'
  export default options
</script>

<template>
	
	<div class="Form__Element FormTextbox FormTextbox--RichText" :class="{ ValidationRequired: isRequired, ValidationError: isValidationError }">
		<label
			:for="fieldName"
			class="Form__Element__Caption"
			>{{ label }}
		</label>
		
		<editor api-key="no-api-key" 
			required
			aria-required="true"
			aria-describedby="fundraiseReason_desc"
			aria-invalid="false"
			:init='{
				placeholder: placeholder,
				plugins: "emoticons autoresize autolink",
				toolbar: "emoticons",
				toolbar_location: "bottom",
				menubar: false,
				statusbar: false,
				license_key: "gpl",
				min_height: 200,
				autoresize_bottom_margin: 30,
				formats: {
                    bold: {},
                    italic: {},
                    underline: {}
                },
                setup(editor) {
                    editor.on("init", () => {
                        editor.setContent(modelValue || "")
                    })
                    editor.on("change keyup", () => {
                        $emit("update:modelValue", editor.getContent())
                    })
                }
		  	}'
            >
		</editor>
	
		<p
			class="kb-forms Form__Element__ValidationError"
			v-if="isValidationError"
			>{{ errorMessageLabel }}
		</p>
	</div>

</template>
